import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import SuccessCircleIcon from '@icons/SuccessCircleIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useMemo } from 'react';
import { usePaymentAndOrder } from '../../payments/PaymentAndOrderContext';
import { parseHighlightedText } from './highlighters';

export default function GoalLandingPageOverviewSection() {
  const { state } = usePaymentAndOrder();
  const overview = useMemo(() => state.goal?.landingPage?.overview, [state.goal]);
  const accentColor = state.goal?.landingPage?.accentColor || DEFAULT_LANDING_PAGE_ACCENT_COLOR;
  if (!overview) return <></>;

  return (
    <div
      className={classNames(
        'w-full flex flex-col items-center',
        // RESPONSIVE STYLES
        'gap-xl @[640px]:gap-xxxl',
        'py-xl @[640px]:py-huge',
        'px-sm'
      )}
    >
      <div className='w-full max-w-[1200px] flex flex-col gap-md items-start text-center'>
        <div
          className={classNames(
            'w-full font-bold leading-[1.2]',
            // RESPONSIVE STYLES
            'text-[28px] @[480px]:text-[32px] @[640px]:text-[48px] break-words'
          )}
        >
          <span style={{ color: accentColor }}>{overview.title}</span>
          <br />
          <span className={classNames(setupForDark('text-white'))}>
            {parseHighlightedText(overview.subtitle, 'text-white', undefined, accentColor)}
          </span>
        </div>
        <div
          className={classNames(
            'w-full font-normal leading-[1.6]',
            setupForDark('text-white'),
            // RESPONSIVE STYLES
            'text-[16px] @[640px]:text-[20px]'
          )}
        >
          {parseHighlightedText(overview.description, 'text-white', undefined, accentColor)}
        </div>
      </div>

      <div
        className={classNames(
          'flex flex-col gap-md items-center',
          // RESPONSIVE STYLES
          'w-full max-w-[800px]'
        )}
      >
        <div
          className={classNames(
            'w-full text-center font-bold leading-[1.2]',
            // RESPONSIVE STYLES
            'text-[20px] @[640px]:text-[24px]',
            setupForDark('text-white')
          )}
        >
          {parseHighlightedText(overview.benefit?.title, 'text-white', undefined, accentColor)}
        </div>
        <div
          className={classNames(
            'flex flex-col gap-md items-start ',
            // RESPONSIVE STYLES
            'w-full px-lg @[640px]:px-none',
            'max-w-[540px]'
          )}
        >
          {(overview.benefit?.items ?? []).map((item, index) => (
            <div key={index} className='w-full flex gap-xs items-center'>
              <div className='shrink-0 w-[24px] h-[24px]'>
                <SuccessCircleIcon size={24} style={{ color: accentColor }} />
              </div>
              <div
                className={classNames(
                  'flex-1 font-normal leading-[1.3]',
                  // RESPONSIVE STYLES
                  'text-[16px] @[640px]:text-[20px]',
                  setupForDark('text-secondary')
                )}
              >
                {parseHighlightedText(item, 'text-secondary', undefined, accentColor)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
